import { base_url, sub_urls } from "../api-urls";
import axios from "axios";
export const LoginApi = {
  GenerateToken: async (payload) => {
    const response = await axios.post(
      base_url + sub_urls.onboarding.getToken,
      {},
      {
        params: {
          mobile: payload.mobile,
          password: payload.password,
        },
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },
  GetMasterTOTP: async () => {
    const response = await axios.post(
      base_url + sub_urls.onboarding.getTOTP,
      {},
      {
        headers: Headers.getHeaders(),
      }
    );
    return response;
  },
};
